import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Breadcrumb, Container, Spinner, Modal, Table } from 'react-bootstrap';
import TimeLine, { TimelineHeaders, SidebarHeader, DateHeader } from 'react-calendar-timeline';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import 'react-calendar-timeline/lib/Timeline.css';
import toastr from "toastr";

import itemRender from './itemRender';
import './vacationRequestsTimeLines.css';
import CustomNavbar from '../../../components/CustomNavbar';
import SidebarDashboard from '../../../components/SidebarDashboard';
import HeaderWithSearchForm from '../../../components/header_with_search_form/HeaderWithSearchForm';
import FilterButtons from '../../../components/filter_buttons/FilterButtons';
import { getFilterButtonsConfig } from './filterButtonsConfig';
import { getScheduleTrackingPlannedVacationsEmployee } from '../../../redux/vacations/schedule_tracking_planned_vacations_employee/actions';
import { findUserRole, isUserEmployee } from '../../../utils/findValueFromArray';
import { searchTypes, roles } from './variables';
import SearchAvanceForm from '../../../components/search_avance_form/SearchAvanceForm';
import useQueryParams from '../../../hooks/useQueryParams';
import {getVacationRequestsByEmployee, updateVacationRequest, clearVacationRequestError} from '../../../redux/vacations/employee_vacation_request/actions';

const RequestsTimeLines = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const { requests, loading, error, saving } = useSelector(state => state.vacationRequests);
  const [showChangesModal, setShowChangesModal] = useState(false);
  const [changeComment, setChangeComment] = useState("");
  const [selectedRequest, setSelectedRequest] = useState(null);

  const history = useHistory();

  const [show, setShow] = useState(false);
  const [isShowSearchAvanceForm, setIsShowSearchAvanceForm] = useState(false);
  const dispatch = useDispatch();
  const { isLoadingData,
  scheludeTrackingPlannedVacationsEmployee,
  scheludeTrackingPlannedVacationsEmployeeFailure } = useSelector(state => state.scheduleTrackingPlannedVacationsEmployee);
  const { userRoles } = useSelector((store) => store.auth);
  
  const isEmployee = isUserEmployee(userRoles);
  const queryParams = useQueryParams();
  const [filter, setFilter] = useState(() => ({
    type: searchTypes.SIMPLE_SEARCH,
    filter: queryParams.get('usercode') ? queryParams.get('usercode') : ''
  }));

  const searchEmployeesEvents = useCallback((ft=filter) => { 
    const params = {
      rol: findUserRole(userRoles, roles),
      anio: moment().year(),
      auto_consulta: queryParams.get('usercode') ? true : false
    }
    params[ft.type === 'SIMPLE_SEARCH' ? 'filtro' : 'filtro_avanzado'] = ft.filter;
    dispatch(getScheduleTrackingPlannedVacationsEmployee(params));
  }, [filter, userRoles, dispatch]);


  useEffect(() => {
    if (userRoles.length > 0) {
      searchEmployeesEvents();
    }
  }, [userRoles, searchEmployeesEvents])
  
  const onShowSidebar = () => setShow(show ? false : true);
  
  const onSearch = (e) => {
    e.preventDefault();
    const ft = {type: searchTypes.SIMPLE_SEARCH, filter: e.target.search.value};
    setFilter(ft);
    searchEmployeesEvents(ft);
  };

  const onListAll = () => {
    const ft = "";
    setFilter(ft);
    searchEmployeesEvents(ft);
  }
  const onShowSearchAvanceForm = () => {
    setIsShowSearchAvanceForm(true);
  }

  const avancedSearch = (avancedSearchParams) => {
    const ft = {
      type: searchTypes.ADVANCED_SEARCH,
      filter: avancedSearchParams
    };
    setFilter(ft);
    searchEmployeesEvents(ft);
  }

  const navigateToVacationBalance = () => {
    history.push('/saldo-vacaciones');
  }

  const filterButtonsConfig = getFilterButtonsConfig(onListAll, onShowSearchAvanceForm, findUserRole(userRoles, roles), navigateToVacationBalance); //setSearchYear, searchYear,

  const orderedRequests = [...requests].sort((a, b) => {
    const order = { "Pendiente": 1, "Cambios": 2, "Aprobado": 3 };
    return order[a.estado] - order[b.estado];
  });
  
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {
            !isEmployee && (
              <Breadcrumb className="mb-3">
                <Breadcrumb.Item href="/saldo-vacaciones">Saldo de vacaciones</Breadcrumb.Item>
                <Breadcrumb.Item active>Solicitudes de vacaciones</Breadcrumb.Item>
              </Breadcrumb>
            )
          }
          <HeaderWithSearchForm 
            onSearch={onSearch} 
            title="Solicitudes de vacaciones"
            showNewRecordButton={false}
            isDisabledSearchControl={isEmployee ? true : false} />
          <hr />
          <div className='mb-3'>
            <FilterButtons buttons={filterButtonsConfig} />
          </div>
          {
            scheludeTrackingPlannedVacationsEmployeeFailure && (
              <Alert variant="danger" className="mt-4 mb-3">
                {scheludeTrackingPlannedVacationsEmployeeFailure}
              </Alert>
            )
          }
          { isLoadingData ? ( <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>) : (
            <TimeLine
              groups={scheludeTrackingPlannedVacationsEmployee ? scheludeTrackingPlannedVacationsEmployee.empleados : []}
              items={scheludeTrackingPlannedVacationsEmployee ? scheludeTrackingPlannedVacationsEmployee.eventos_empleados : []}
              itemRenderer={itemRender}
              lineHeight={75}
              sidebarWidth={350}
              sidebarContent="Classes"
              defaultTimeStart={moment().add(-12, 'hour')}
              defaultTimeEnd={moment().add(720, 'hour')}
              maxZoom={1.5 * 365.24 * 86400 * 1000}
              minZoom={1.24 * 86400 * 1000 * 7 * 3}
              fullUpdate
              itemTouchSendsClick={false}
              stackItems
              itemHeightRatio={0.75}
              showCursorLine
              canMove={true}
              canResize={'both'} 
              groupRenderer={({ group }) => (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "0 8px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
                >
                  <span
                    style={{
                      flex: 1,
                      minWidth: 0,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                    title={group.title}
                  >
                    {group.title}
                  </span>

                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    style={{
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                      backgroundColor: "#6c757d",
                      borderColor: "#6c757d",
                      color: "white"
                    }}
                    onClick={() => {
                      setSelectedEmployee(group.id);
                      dispatch(clearVacationRequestError());
                      setShowModal(true);
                      dispatch(getVacationRequestsByEmployee(group.id));
                    }}
                  >
                    Ver solicitudes
                  </button>
                </div>
              )}
              >
              <TimelineHeaders className="time-line-header">
                <SidebarHeader>
                  {({ getRootProps }) => {
                    return <div className="d-flex justify-content-center align-items-center"><h6 {...getRootProps()} className="sidebar-header-text-color" >Empleados</h6></div>;
                  }}
                </SidebarHeader>
                <DateHeader unit="primaryHeader" />
                <DateHeader />
              </TimelineHeaders>
            </TimeLine>
          ) }
        </Container>
      </div>
      <SearchAvanceForm 
        isShowSearchModal={isShowSearchAvanceForm} 
        setIsShowSearchModal={setIsShowSearchAvanceForm}
        searchFunc={avancedSearch} />
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Solicitudes del empleado {selectedEmployee}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && !showChangesModal && (<Alert variant="danger">{error}</Alert>)}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" />
            </div>
          ) : requests.length === 0 ? (
            <Alert variant="info">Este empleado no tiene ninguna solicitud.</Alert>
          ) : (
            <div className="table-responsive" style={{ maxHeight: "450px", overflowY: "auto" }}>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Tipo</th>
                    <th>Fecha inicio</th>
                    <th>Fecha fin</th>
                    <th>Estado</th>
                    {/*<th>Horas</th>*/}
                    <th>Comentario</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {orderedRequests.map((req, idx) => (
                    <tr
                      key={req.id}
                      className={
                        req.estado === "Pendiente" ? "table-warning" :
                        req.estado === "Cambios" ? "table-info" :
                        req.estado === "Aprobado" ? "table-success" : ""
                      }
                    >
                      <td>{req.id}</td>
                      <td>{req.tipo}</td>
                      <td>{req.fecha_inicio}</td>
                      <td>{req.fecha_fin}</td>
                      <td>{req.estado}</td>
                      {/*<td>{req.horas}</td>*/}
                      <td>{req.comentario}</td>
                      <td>
                        <button 
                          className="btn btn-success btn-sm"
                          style={{marginRight: "5px"}}
                          disabled={req.estado === "Aprobado"}
                          onClick={async () => {
                            await dispatch(updateVacationRequest(req.id, {
                              estado: "Aprobado",
                              codigo_empleado: selectedEmployee
                            }));
                            toastr.success("Solicitud aprobada");
                          }}
                        >
                          Aprobar
                        </button>
                        <button 
                          className="btn btn-info btn-sm"
                          disabled={
                            req.estado === "Cambios" ||
                            (
                              req.estado === "Aprobado" &&
                              moment(req.fecha_inicio, "YYYY-MM-DD").isSameOrBefore(
                                moment().add(3, "days"),
                                "day"
                              )
                            )
                          }
                          onClick={() => {
                            setSelectedRequest(req.id);
                            setChangeComment("");
                            dispatch(clearVacationRequestError());
                            setShowChangesModal(true);
                          }}
                        >
                          Cambios
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <Modal 
      show={showChangesModal} 
      onHide={() => {
        setShowChangesModal(false);
        setChangeComment("");
        dispatch(clearVacationRequestError());
      }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Solicitar cambios</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && (<Alert variant="danger">{error}</Alert>)}
          <textarea
            className="form-control"
            rows={4}
            value={changeComment}
            onChange={(e) => setChangeComment(e.target.value)}
            placeholder="Escriba los cambios que requiere la solicitud..."
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            disabled={saving}
            onClick={() => {
              setShowChangesModal(false);
              setChangeComment("");
              dispatch(clearVacationRequestError());
            }}
          >
            Cancelar
          </button>
          <button
            className="btn btn-warning"
            disabled={saving}
            onClick={async () => {
              const success = await dispatch(
                updateVacationRequest(selectedRequest, {
                  estado: "Cambios",
                  comentario: changeComment,
                  codigo_empleado: selectedEmployee
                })
              );
              if (success) {
                setShowChangesModal(false);
                setChangeComment("");
                toastr.success("Solicitud de cambio enviada");
              }
            }}
          >
            {saving ? "Enviando..." : "Enviar cambios"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default RequestsTimeLines;